export default __webpack_public_path__ + "static/media/sepa-iban.5ac46210.png";